// extracted by mini-css-extract-plugin
var _1 = "cAvdP";
var _2 = "VkCPb";
export { _1 as "ctaButtonPosition", _2 as "splashAspectRatio" }
